function Home() {
  return (
    <div class="content" style={{ padding: 20 }}>
      <h2>Home View</h2>
      <p>Content soon to come.</p>
    </div>
  );
}

export default Home;